/*
 * @Descripttion: 针对面的外边框捕捉
 * @version: 1.0
 * @Author: zhangxiaofeng
 * @Date: 2020-11-04 17:06:51
 * @LastEditors: zhangxiaofeng
 * @LastEditTime: 2020-11-04 17:32:47
 */
import SnapActor from './SnapActor';
import getSymbol from "../style";

/**
 * 要素捕捉行为类,用于对指定要素类型进行捕捉
 * 对应的指定要素类型一般是通过传入指定要素的场景图层id实现.
 */
export default class FeatureOutLineSnapActor extends SnapActor {
    constructor(options) {
        super({
            filter: null, // 过滤函数
            ...options
        });

        /**
         * 捕捉到的要素对象
         * @type {object}
         */
        this.snapFeature = null;
        this.coordinatesIndex = 0;
    }

    clear() {
        super.clear();
        this.snapFeature = null;
        this.coordinatesIndex = 0;
    }

    /**
     * 捕捉方法
     * @param {object<geojson>} point 点经纬度几何，一般是鼠标的位置
     * @returns {object} snapResult - 捕捉结果
     */
    snap(point) {
        super.snap(point);

        const box = this.getBox(point);
        const features = this._featureSelector.selectByGeometry(box, this.options.filter);

        if (features.length === 0) {
            return null;
        }

        let minDis = Number.MAX_VALUE;
        const pointPixel = this._geojsonConverter.lngLatToPixel(point);
        for (let i = 0; i < features.length; ++i) {
            const feature = features[i];

            // 支持多面，带孔几何
            const pixelGeo = this._geojsonConverter.lngLatToPixel(feature.geometry);
            let nearList = [];
            for (let index = 0; index < pixelGeo.coordinates.length; index++) {
              const element = pixelGeo.coordinates[index];
              let line = {
                type: 'LineString',
                coordinates: element
              }
              const nearLine = this.nearestPoints(pointPixel, line);
              nearList.push({
                nearLine: nearLine,
                index: index
              })
            }
            nearList.sort((a,b) => a.nearLine.distance - b.nearLine.distance);
            if (nearList[0].nearLine.distance < minDis) {
                minDis = nearList[0].nearLine.distance;
                this.snapPoint = nearList[0].nearLine.point2;
                this.snapFeature = feature;
                this.coordinatesIndex = nearList[0].index
            }
        }
        if (this.snapPoint) {
            this.snapPoint = this._geojsonConverter.pixelToLngLat(this.snapPoint);
        }

        return this.getSnapResult();
    }

    /**
     * 获得计算得到的最终捕捉数据结构.
     * @returns {object}
     */
    getSnapResult() {
        const result = super.getSnapResult();
        if (result) {
            result.feature = this.snapFeature;
            result.coordinatesIndex = this.coordinatesIndex;
        }

        return result;
    }

    /**
     * 获取捕捉时的要绘制的图标信息
     * @return {array}
     */
    getDrawItems() {
        if (this.snapPoint) {
            return [
                {
                    geometry: this.snapPoint, // geojson
                    symbol: getSymbol('snap_pt_outline') // symbol json
                }
            ];
        }
        return [];
    }
}
